import React from 'react';
import { connect } from 'react-redux';
import { withTranslation, WithTranslation } from 'react-i18next';
import { ApplicationState } from '../../store';
import { SettingsState } from '../../types/redux/SettingsTypes';

// Component State
interface IStateProps {

}

// Component Props
interface IOwnProps {
    input: React.InputHTMLAttributes<HTMLInputElement>;
    type: string;
    meta: {
        touched: boolean;
        error?: string;
    };
}

// Redux State Props
interface IReduxStateProps {
    settings: SettingsState
}

// Redux Dispatch Props
interface IReduxDispatchProps {

}

type Props = IOwnProps & IReduxStateProps & IReduxDispatchProps & WithTranslation;

class FieldCheckboxOrderAgree extends React.PureComponent<Props, IStateProps> {
    render() {
        const { input, type, meta, t } = this.props;
        const { touched, error } = meta;

        return (
            <div className={ `checkbox ${ touched && error ? 'has-error' : '' }` }>
                { touched && error && <b className="help-block">{ error }</b> }
                <label>
                    <input { ...input } type={ type } />
                    { t( 'basket.wizard.contact.checkboxOrderPrefix' ) }{ ' ' }
                    <a target="_blank" rel="noopener noreferrer" href={ this.props.settings.links.termsAndConditionsLink }>
                        { t( 'basket.wizard.contact.checkboxOrderTerms' ) }
                    </a>{ ' ' }
                    { t( 'basket.wizard.contact.checkboxOrderAnd' ) }{ ' ' }
                    <a target="_blank" rel="noopener noreferrer" href={ this.props.settings.links.privacyPolicyLink }>
                        { t( 'basket.wizard.contact.checkboxOrderPrivacy' ) }
                    </a>.
                </label>
            </div>
        );
    }
}

const mapStateToProps = ( state: ApplicationState ): IReduxStateProps => ( {
    settings: state.settingsReducer
} );

const mapDispatchToProps = ( dispatch: Function ): IReduxDispatchProps => ( {

} );

export default connect<IReduxStateProps, IReduxDispatchProps, IOwnProps, ApplicationState>(
    mapStateToProps,
    mapDispatchToProps
)( withTranslation()( FieldCheckboxOrderAgree ) );
